import type { ReactNode } from 'react'
import { btn } from '../../lib/ui'

type Props = {
  title: string
  titleId?: string
  onClose: () => void
  children: ReactNode
}

export function Modal({ title, titleId = 'modal-title', onClose, children }: Props) {
  return (
    <div
      className="fixed inset-0 z-2000 flex items-center justify-center bg-slate-900/45 p-4"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-xl bg-su-surface p-5 shadow-2xl"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onClick={(ev) => ev.stopPropagation()}
      >
        <h3 id={titleId} className="mb-4 text-lg font-semibold text-su-text-strong">
          {title}
        </h3>
        {children}
      </div>
    </div>
  )
}

export function ModalActions({ children }: { children: ReactNode }) {
  return <div className="mt-4 flex flex-wrap gap-2">{children}</div>
}

export { btn as modalBtn }
